<app-sidebar>
  <div class="history-page">
    <div class="page-header">
      <h1>Search History</h1>
      <p>Search history over all time</p>
    </div>

    <div class="history-loading-state" *ngIf="isLoadingHistory">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ loadingMessage }}</p>
    </div>

    <div class="history-empty-state" *ngIf="!isLoadingHistory && !consentRequired && !hasRequests">
      <mat-icon>event_note</mat-icon>
      <p>No requests available yet.</p>
    </div>

    <div class="history-card" *ngIf="!isLoadingHistory && hasRequests">
      <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let request">{{ getCustomerName(request) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="searchCriteria">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Search Criteria</mat-header-cell>
          <mat-cell *matCellDef="let request">{{ getSearchCriteria(request) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <mat-icon [color]="getStatusColor(request.status)">{{ getStatusIcon(request.status) }}</mat-icon>
            {{ getStatusLabel(request) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</mat-header-cell>
          <mat-cell *matCellDef="let request">{{ formatDate(request.createdAt) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="availability">
          <mat-header-cell *matHeaderCellDef>Availability</mat-header-cell>
          <mat-cell *matCellDef="let request" [matTooltip]="!isMultiSearch(request) ? getAvailabilityTooltip(request) : ''">
            <ng-container *ngIf="isMultiSearch(request); else standardAvailability">
              -
            </ng-container>
            <ng-template #standardAvailability>
            <span class="availability-chip">
              <mat-icon [color]="getAvailabilityIconColor(request)">{{ getAvailabilityIcon(request) }}</mat-icon>
              {{ getAvailabilityText(request) }}
            </span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let request">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Open multi search"
              *ngIf="isMultiSearch(request)"
              (click)="openMultiSearch(request)">
              <mat-icon>view_list</mat-icon>
            </button>
            <span
              *ngIf="!isMultiSearch(request) && request.status === 'COMPLETE'"
              [matTooltip]="canViewRequest(request) ? 'View data' : getViewDisabledReason(request)">
              <button
                mat-icon-button
                color="primary"
                (click)="viewData(request)"
                [disabled]="!canViewRequest(request)">
                <mat-icon>visibility</mat-icon>
              </button>
            </span>
            <button
              mat-icon-button
              color="warn"
              (click)="cancelRequest(request.requestId)"
              *ngIf="!isMultiSearch(request) && (request.status === 'IN_PROGRESS' || request.status === 'QUEUED')"
              matTooltip="Cancel Request">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="50"></mat-paginator>
    </div>
  </div>
</app-sidebar>
